import { createSlice } from '@reduxjs/toolkit';
import { FinaliseShipmentState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { finaliseShipmentThunk } from './thunks';

// Initial State
const initialState: FinaliseShipmentState = {
  errors: null,
  status: StoreStatus.IDLE,
  values: null,
  response: null,
};

// Slice
export const finaliseShipmentSlice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    resetFinaliseShipment: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(finaliseShipmentThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(finaliseShipmentThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
      state.values = null;
    });
    builder.addCase(finaliseShipmentThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { resetFinaliseShipment } = finaliseShipmentSlice.actions;
export * from './thunks';
export default finaliseShipmentSlice.reducer;
